import IMask from 'imask';
import { AnyMasked } from 'react-imask';

import { PHONE_INPUT_MASK_DATA } from '~/constants/variables';

export const maskDispatch = (
  appended: string,
  dynamicMasked: AnyMasked,
): AnyMasked => {
  const number = (dynamicMasked.value + appended).replace(/\D/g, '');
  return dynamicMasked.compiledMasks.find(
    (m: AnyMasked) => number.indexOf(m.startsWith) === 0,
  );
};

export const createMasked = () =>
  IMask.createMask({
    mask: PHONE_INPUT_MASK_DATA,
    dispatch: maskDispatch,
  });
